import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderLayout } from '@layouts';
import {
  Grid,
  Stack,
  List,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import { useMenuContext } from '@hooks';
import { updateMenuSection } from '@api';
import { arrangeMenu } from '@utils/menu';
import ManageMenuItem from '@components/ManageMenuItem';
import PrimaryButton from '@components/PrimaryButton';
import SwitchStyled from '@components/SwitchStyled';
import { createProduct } from '../../api/products';
import { useStyles } from './styles';

function MenuItem({ item, selected, setSelected }) {
  const [checked, updateChecked] = useState(item.enabled);

  const changeItemState = () => {
    updateMenuSection(item.id, item.enabled);
    updateChecked(!checked);
  };

  return (
    <>
      <ListItem
        button
        sx={{
          border: `1px solid rgba(255,255,255,.3)`,
          borderRadius: 10,
          marginTop: 10,
          '&.MuiListItem-gutters': {
            paddingRight: 0,
          },
        }}
      >
        <ListItemText primary={item.name} />
        <SwitchStyled checked={checked} onChange={changeItemState} />
      </ListItem>
      <List component="div" disablePadding>
        {item.children.map(item => (
          <ManageMenuItem
            key={item.id}
            item={item}
            selected={selected}
            setSelected={setSelected}
          />
        ))}
      </List>
    </>
  );
}

function MenuItemHeader() {
  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={12} lg={6}>
        {/*<InputTextField*/}
        {/*  type="text"*/}
        {/*  styles={{ width: '100%', height: 46 }}*/}
        {/*  inputStyles={{ height: 46 }}*/}
        {/*  value={search}*/}
        {/*  placeholder="Search a Product"*/}
        {/*  handleChangeInput={handleChangeSearch}*/}
        {/*  isError={false}*/}
        {/*  StartAdornementIcon={SearchIcon}*/}
        {/*/>*/}
      </Grid>
      <Grid
        item
        container
        xs={12}
        sm={6}
        lg={3}
        justifyContent="flex-end"
        pb={2}
      >
        {/*<Typography*/}
        {/*  sx={{*/}
        {/*    my: 'auto',*/}
        {/*    fontSize: theme.fonts.sizes.font12PX,*/}
        {/*    fontWeight: theme.typography.fontWeightBold,*/}
        {/*    color: theme.colors.light.lightSteelBlue,*/}
        {/*    width: 57,*/}
        {/*  }}*/}
        {/*>*/}
        {/*  {t('showInactive')}*/}
        {/*</Typography>*/}
        {/*<SwitchStyled*/}
        {/*  sx={{ my: 'auto' }}*/}
        {/*  checked={showActiveItems}*/}
        {/*  onChange={handleShowActiveItems}*/}
        {/*/>*/}
        {/* <Typography variant="h4">
          {t('itemsIn')}
          {' '}'{`${
            props.fetchedStructure.find(item => item.id === props.selectedSubmenuItem)
              ?.name}`}'
        </Typography> */}
      </Grid>
      <Grid item xs={12} sm={6} lg={3} display="flex" alignItems="center">
        <PrimaryButton
          text={'Add Product'}
          handleClick={() => createProduct()}
          customStyle={{ my: 'auto' }}
        />
      </Grid>
    </Grid>
  );
}
function MenuItemTitle({ t }) {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      pl={6.625}
      pr={3.875}
      pt={2}
      sx={{
        fontSize: theme.colors.font12PX,
        fontWeight: theme.typography.fontWeightBold,
        color: theme.colors.light.lightSteelBlue,
      }}
    >
      <Typography fontSize="inherit" fontWeight="inherit">
        {t('product')}
      </Typography>
      <Typography fontSize="inherit" fontWeight="inherit">
        {t('price')}
      </Typography>
    </Stack>
  );
}
function MenuItemsEditor({
  fetchedMenu,
  selectedSubmenuItem,
  setSelectedSubmenuItem,
  showActiveItems,
}) {
  return (
    <List disablePadding aria-labelledby="nested-list-subheader">
      {fetchedMenu
        .filter(item => item.menuSection === selectedSubmenuItem)
        .filter(item => item.enabled === showActiveItems) // show only active items
        .map(item => {
          return (
            <ManageMenuItem
              key={item.id}
              item={item}
              selected={selectedSubmenuItem}
              setSelected={setSelectedSubmenuItem}
              itemsExist
            />
          );
        })}
    </List>
  );
}

export default function ManageMenu() {
  const { t } = useTranslation('menu');
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [selectedSubmenuItem, setSelectedSubmenuItem] = useState('');
  const [showActiveItems, setShowActiveItems] = useState(true);

  const {
    fetchedMenu,
    fetchedStructure,
    fetchMenuSectionsListForService,
  } = useMenuContext();

  const arrangedMenu = useMemo(() => arrangeMenu(fetchedStructure), [
    fetchedStructure,
  ]);

  useEffect(() => {
    fetchMenuSectionsListForService();

    setLoading(false);
    if (fetchedMenu?.length === 0 || fetchedStructure?.length === 0) {
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSelectedSubmenuItem(arrangedMenu[0]?.children[0]?.id);
  }, [fetchedStructure, arrangedMenu]);

  const setSelected = menuItem => {
    window.scrollTo(0, 0);
    setSelectedSubmenuItem(menuItem);
  };

  const handleShowActiveItems = ({ target: { checked } }) => {
    setShowActiveItems(checked);
  };

  return (
    <HeaderLayout>
      {!loading && arrangedMenu.length && (
        <Grid container justify="space-between">
          <Grid item md={5} sm={6} className={classes.container}>
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
              subheader={
                <Typography gutterBottom variant="h4">
                  Menu Sections
                </Typography>
              }
              className={classes.root}
            >
              {arrangedMenu.map(defaultMenu => (
                <MenuItem
                  selected={selectedSubmenuItem}
                  setSelected={setSelected}
                  key={defaultMenu.id}
                  item={defaultMenu}
                />
              ))}
            </List>
          </Grid>
          <Grid
            item
            sx={{
              padding: 2.5,
              flex: 2 / 3,
              color: 'white',
            }}
          >
            <MenuItemHeader
              t={t}
              showActiveItems={showActiveItems}
              handleShowActiveItems={handleShowActiveItems}
            />
            <MenuItemTitle t={t} />
            <MenuItemsEditor
              fetchedMenu={fetchedMenu}
              showActiveItems={showActiveItems}
              selectedSubmenuItem={selectedSubmenuItem}
              setSelectedSubmenuItem={setSelectedSubmenuItem}
            />
          </Grid>
        </Grid>
      )}
    </HeaderLayout>
  );
}
